import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AdminService } from 'src/app/services/admin/admin.service';
import { ToastrService } from 'ngx-toastr';
import { SpinnerComponent } from 'src/app/components/layout/spinner/spinner.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-verify',
  standalone: true,
  imports: [
    SpinnerComponent,
    CommonModule, 
    TranslateModule,
    RouterModule
  ],
  templateUrl: './verify.component.html',
  styleUrls: ['./verify.component.css']
})
export class VerifyComponent implements OnInit {
  loading = false;
  error = false; // შეცდომის კონტროლი

  constructor(
    private admin: AdminService,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.verifyEmail();
  }

  verifyEmail() {
    this.loading = true;
    const token = this.route.snapshot.queryParamMap.get('token');
    const email = this.route.snapshot.queryParamMap.get('email');
    console.log(token)
    if (!token || !email) {
      this.toastr.error('ვერიფიკაციის ბმული არასწორია');
      this.error = true;
      this.loading = false;
      // this.router.navigate(['/']);
      return;
    }

    this.admin.verifyEmail({ token, email }).subscribe(
      (res: any) => {
        console.log(res);
        this.loading = false;
        // this.toastr.success('ელ.ფოსტა წარმატებით ვერიფიცირდა');
        setTimeout(() => {
          this.router.navigate(['/']);
        }, 3000);
      },
      (error: any) => {
        console.log(error);
        // this.toastr.error('ვერიფიკაციისას შეცდომა მოხდა');
        this.error = true;
        this.loading = false;
      }
    );
  }
}